import type { Coordinates } from '../TextParticles.types';

// Returns coordinates for not transparent parts of the image
export const getValidImageCoordinates = (
  imageData: ImageData,
  particleSize: number,
) => {
  const OPACITY_THRESHOLD = 10;
  const { width, height, data } = imageData;
  const validImageCoordinates: Array<Coordinates> = [];

  // Check if any pixel opacity within block is larger than OPACITY_THRESHOLD
  const isValidImageBlock = (blockX: number, blockY: number) => {
    for (let pixelY = 0; pixelY < particleSize; pixelY++) {
      for (let pixelX = 0; pixelX < particleSize; pixelX++) {
        const srcX = blockX + pixelX;
        const srcY = blockY + pixelY;
        if (srcX < width && srcY < height) {
          const srcIndex = (srcY * width + srcX) * 4;
          if (data[srcIndex + 3] > OPACITY_THRESHOLD) {
            return true;
          }
        }
      }
    }
    return false;
  };

  for (let y = 0; y < height; y += particleSize) {
    for (let x = 0; x < width; x += particleSize) {
      if (isValidImageBlock(x, y)) {
        validImageCoordinates.push({ x, y });
      }
    }
  }

  return validImageCoordinates;
};

// After transferring image bitmap to worker context, main thread can still have a reference to image
// but its value is in the worker context https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Transferable_objects
export const isImageTransferred = (imageBitmap: ImageBitmap) =>
  imageBitmap && imageBitmap.width === 0 && imageBitmap.height === 0;
